import React, { useEffect, useState } from "react";
import { getFonts, deleteFont } from "../../../api/fontService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import Pagination from "../../Pagination/Pagination";
import { useNavigate } from "react-router-dom";

export default function FontList() {
  const [fonts, setFonts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const navigate = useNavigate();

  const fetchFonts = async () => {
    try {
      setLoading(true);

      const response = await getFonts({
        page: currentPage,
        limit: itemsPerPage,
        search,
        sort,
      });


      setFonts(response?.data || []);
      setTotalItems(response?.pagination?.total || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFonts();
  }, [currentPage, search, sort]);

  const handleDelete = async (id) => {
    try {
      await deleteFont(id);
      fetchFonts();
    } catch (error) {

    }
  };
  return (
    <div className="container-fluid p-4 np-font-options-page">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Font List</h5>

        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control"
            style={{ width: "220px" }}
            placeholder="Search font..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />

          <select
            className="form-select border-0"
            value={sort}
            onChange={(e) => {
              setSort(e.target.value);
              setCurrentPage(1);
            }}
            style={{ width: "100px" }}
          >
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/font/add")}
          >
            <FaPlus />
            Add Font
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="text-center py-3">Loading...</div>
          ) : (
            <table
              className="table table-bordered table-hover align-middle mb-0"
              style={{ tableLayout: "fixed" }}>
              <thead className="table-light">
                <tr>
                  <th style={{ width: "20px", fontWeight: "bold" }}>#</th>
                  <th style={{ width: "30px", fontWeight: "bold" }}>Font Name</th>
                  <th style={{ width: "20px", fontWeight: "bold" }}>Status</th>
                  <th
                    style={{ width: "20px", fontWeight: "bold" }}
                    className="text-center"
                  >
                    ACTION
                  </th>
                </tr>
              </thead>
              <tbody>
                {fonts.length > 0 ? (
                  fonts.map((font, index) => (
                    <tr key={font._id}>
                      <td>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>

                      <td>{font.name}</td>



                      <td>
                        <span
                          className={`badge ${font.status === "ACTIVE"
                              ? "bg-success"
                              : "bg-danger"
                            }`}
                        >
                          {font.status}
                        </span>
                      </td>

                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            className="btn btn-sm np-table-action-btn"
                            onClick={() =>
                              navigate(`/font/view`, {
                                state: { fontId: font._id },
                              })
                            }
                          >
                            <FaEye />
                          </button>

                          <button
                            className="btn btn-sm np-table-action-btn"
                            onClick={() =>
                              navigate(`/font/edit/${font.name}`, {
                                state: { fontId: font._id },
                              })
                            }
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="btn btn-sm np-table-action-btn"
                            onClick={() => handleDelete(font._id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No fonts found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="card-footer d-flex justify-content-end">

        </div>

      </div>
      <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
}